export const workerKey = {
  all: ["worker"] as const,
};

export const robotKey = {
  all: ["worker", "robot"] as const,
  list: () => [...robotKey.all, "list"] as const,
  detail: (robotId: string) => [...robotKey.all, robotId] as const,
};

export const mapKey = {
  all: ["worker", "map"] as const,
  list: () => [...mapKey.all, "list"] as const,
  detail: (mapId: string) => [...mapKey.all, mapId] as const,
};

export const cleaningEventKey = {
  all: ["worker", "cleaningEvent"] as const,
  listByDate: (startDate: Date, endDate: Date) =>
    [
      ...cleaningEventKey.all,
      "list",
      startDate.getTime(),
      endDate.getTime(),
    ] as const,
  listByRobot: (robotId: string) => [
    ...cleaningEventKey.all,
    "list",
    "robot",
    robotId,
  ],
  listByMap: (mapId: string) => [...cleaningEventKey.all, "list", "map", mapId],
  detail: (eventId: string) => [...cleaningEventKey.all, eventId] as const,
};
